// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"23399bfd","453":"9ab32b70"}[chunkId] + ".chunk.js";
};